import { render, staticRenderFns } from "./ahStickyElTableHeader.vue?vue&type=template&id=52872410&scoped=true&"
import script from "./ahStickyElTableHeader.vue?vue&type=script&lang=js&"
export * from "./ahStickyElTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./ahStickyElTableHeader.vue?vue&type=style&index=0&id=52872410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52872410",
  null
  
)

export default component.exports